import React from 'react'
import numberToWords from 'number-to-words';
import { motion } from 'framer-motion'
import { img1 } from '../../assets'
import {Button} from '../'
import { BadgeRoundedIcon } from '../../utils/constants'
import './hero.css'

const Hero = () => {
  const currentYear = new Date().getFullYear();
  
  // Specify the target year (2021 in this case)
  const targetYear = 2018;

  // Calculate the difference
  const yearDifference = currentYear - targetYear;
  
  return (
    <>
      <section id='home' className='hero-main-wrapper'>
        <motion.div whileInView={{ x: [-100, 0], opacity: [0, 1] }} transition={{ duration: 1 }} className='hero-content'>
          <div className='hero-intro'>Hello, i am <span className='hero-intro-name'>Oluwasanmi,</span></div>
          <small className='hero-small'>since beginning my journey as a <span className='hero-glow'>Software Developer</span> and freelancer nearly {numberToWords.toWords(yearDifference)}({yearDifference.toString()}) years ago, i have done remote work for agencies, consulted for startups and collaborated with talented individuals to create digital products for both business and consumer use... I am confident, curious and perpetually working on improving, developing and solving one problem at a time.</small>
          <Button buttonWrapper="button-wrapper" hrefHashTagButton linkTo="contact" linkClass="link-wrapper" linkIcon={<BadgeRoundedIcon />} linkName="Hire Me" />
        </motion.div>
        <div className='hero-image'>
          <img src={img1} alt='hero-img' />
        </div>
      </section>
    </>
  )
}

export default Hero